/*
 * General custom scripts
 */

/*
 * Page Header
 */
import { Header } from "./front/parts/header";
new Header();

/*
 * Section Text Image Keyfacts
 */
import { SectionTextImageKeyfacts } from "./front/components/section-text-image-keyfacts";
window.addEventListener( "DOMContentLoaded", () => {

	document
		.querySelectorAll( ".c-section-text-image-keyfacts" )
		.forEach( ( block ) => {

			new SectionTextImageKeyfacts( block );

		} );

} );
